/**
 * Fokussiert das erste Text- oder Zahlenfeld in einem Formular,
 * sofern das Formular kein "input[name='salutation_type']" enthält.
 * by Daniel Schmidt
 */
function focusFirstTextOrNumberField(form) {
    //console.log("Prüfe Formular:", form.name);

    // Überspringen, falls "salutation_type" existiert
    if (form.querySelector('input[name="salutation_type"]')) {
        //console.log("Formular enthält input[name='salutation_type'], Fokus wird übersprungen.");
        return;
    }

    // Erstes Text- oder Zahlenfeld finden
    const firstTextInput = form.querySelector('input[type="text"], input[type="number"], input[type="email"]');
    if (firstTextInput) {
        //console.log("Fokussiere Eingabefeld:", `ID=${firstTextInput.id}, Name=${firstTextInput.name}`);

        // Fokus setzen
        firstTextInput.focus();
        firstTextInput.tabIndex = 0;

        // Optional: Eltern-DIV hervorheben
        const parentDiv = firstTextInput.closest("div");
        //console.log(parentDiv);
        if (parentDiv) {
            parentDiv.classList.add("is-focused");
        }

        // Cursor an das Textende setzen (wenn 'type="text"')
        if (firstTextInput.type === "text") {
            const length = firstTextInput.value.length;
            firstTextInput.setSelectionRange(length, length);
        }
    } else {
        //console.log("Kein Text- oder Zahlenfeld im Formular gefunden:", form.name);
    }
}

/**
 * Initialisiert einen IntersectionObserver für alle Formulare in .modal-Elementen.
 * Sobald ein solches Formular im Sichtbereich ist, wird das erste Eingabefeld fokussiert.
 */
function initFocusObserverForForms() {
    //console.log("initFocusObserverForForms gestartet.");

    // ALLE Formulare innerhalb eines Elements mit .modal selektieren
    const forms = document.querySelectorAll('.modal form');
    if (forms.length === 0) {
        //console.log("Keine Formulare innerhalb von .modal gefunden.");
        return;
    }

    // IntersectionObserver-Optionen (ab welchem Sichtbarkeits-Anteil etwas "sichtbar" ist)
    const observerOptions = {
        threshold: 0.1, // Beispiel: ab 10% Sichtbarkeit
    };

    // Callback: wird aufgerufen, wenn sich der Sichtbarkeitsstatus ändert
    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                // Formular ist sichtbar
                //console.log("Formular sichtbar:", entry.target.name);
                focusFirstTextOrNumberField(entry.target);
            }
        });
    };

    // Observer anlegen
    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Alle gefundenen Formulare beobachten
    forms.forEach((form) => observer.observe(form));
}
//für Elemente im main-DOM
function initFocusObserverForContent() {
    //console.log("initFocusObserverForContent gestartet.");

    // ALLE Formulare innerhalb von <main> .contact selektieren
    const forms = document.querySelectorAll('main form.alpineForm:nth-child(1)');
    if (forms.length === 0) {
        //console.log("Keine Formulare innerhalb von <main> .contact gefunden.");
        return;
    }

    const observerOptions = {
        threshold: 0.1,
    };

    const observerCallback = (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                //console.log("Formular sichtbar im main:", entry.target.name);
                focusFirstTextOrNumberField(entry.target);
            }
        });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    // Only set foxus to first form which comes in viewport, else it would be causing content-jumps (tabindex)
    observer.observe(forms[0]);
}

document.addEventListener("alpine:init", () => {
    initFocusObserverForForms();
    initFocusObserverForContent();
    //console.log("Alpine.js initialized: initFocusObserverForForms called.");
});


// Optional im globalen Scope bereitstellen, falls du es manuell aufrufen willst
window.initFocusObserverForForms = initFocusObserverForForms;
window.initFocusObserverForContent = initFocusObserverForContent;
